import axios from "@/api/axios";
import store from "@/store";
import _ from "lodash";
import qs from "qs";

// 토큰 가지고 오기
const getToken = async (param, result) => {
  let finalData = {
    timezone: {
      timezone_name: "",
      timezone_offset: 0,
      state: "",
    },
    message: "",
  };
  const options = {
    method: "POST",
    url: "/login",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify({
      id: param.id,
      password: param.password,
    }),
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        store.commit("setTimezone", {
          timezone_name: response.data.timezone.timezone_name,
          timezone_offset: response.data.timezone.timezone_offset,
          state: response.data.timezone.state,
        });
        store.dispatch("login", {
          userId: response.data.loginresult.owner_id,
          userName: response.data.loginresult.nickname,
        });
        if (param.rememberYn) {
          sessionStorage.setItem("token", response.data.loginresult.token);
          localStorage.setItem(
            "remember_id",
            response.data.loginresult.owner_id
          );
          localStorage.setItem("remember_yn", "y");
        } else {
          // localStorage.removeItem("token");
          sessionStorage.setItem("token", response.data.loginresult.token);
          localStorage.removeItem("remember_id");
          localStorage.removeItem("remember_yn");
        }
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("getToken", err);
    result(false, err);
  }
};

const logout = async (token, result) => {
  const options = {
    method: "POST",
    url: process.env.VUE_APP_API_URL + "/app/membership/player/logout.php",
    //url: 'http://localhost/test.php',
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: {
      token: token,
    },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data.message);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("logout", err);
    result(false, err);
  }
};

const forgotPw = async (form, result) => {
  let finalData = {
    code: "",
    message: "",
  };
  const options = {
    method: "POST",
    url: process.env.VUE_APP_API_URL + "/app/membership/player/findpwd.php",
    //url: 'http://localhost/test.php',
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: {
      email: form.email,
    },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data.message);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("forgotPw", err);
    result(false, err);
  }
};

// 캡챠 서버체크 - 대기
const check_captcha = async (form, result) => {
  const options = {
    method: "POST",
    url: "https://www.google.com/recaptcha/api/siteverify",
    //url: 'http://localhost/test.php',
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: {
      secret: "6LdJReccAAAAAGd-qvVpWzDt1_xlOYm0LbgYp-yO",
      response: form.recaptcha_token,
      remoteip: "61.101.55.231",
    },
  };
  try {
    await axios(options).then((response) => {
      console.log(response);
    });
  } catch (err) {
    console.error("check_captcha", err);
    result(false, err);
  }
};

// 회원가입 중복체크
const availability_check = async (type, name, result) => {
  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/app/membership/player/check.php",
    //url: 'http://localhost/test.php',
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    params: {
      searchtype: type,
      searchname: name,
    },
  };
  try {
    await axios(options).then((response) => {
      result(true, response.data.code);
    });
  } catch (err) {
    console.error("availability_check", err);
    result(false, err);
  }
};

// 회원가입
const sign_up = async (form, result) => {
  const options = {
    method: "POST",
    url: process.env.VUE_APP_API_URL + "/app/membership/player/register.php",
    //url: 'http://localhost/test.php',
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: {
      id: form.id,
      password: form.password,
      email: form.email,
      nickname: form.nick,
      firstname: form.first_name,
      lastname: form.last_name,
      timezone: form.timezone,
      daylighttime: form.daylighttime,
      gender: form.gender,
      hand: form.hand,
      teeheight: form.teeheight,
      fieldunit: form.fieldunit,
      greenunit: form.greenunit,
      speedunit: form.speedunit,
      emailagree: form.emailagree,
      pravacy: form.pravacy,
    },
  };

  try {
    await axios(options).then((response) => {
      result(true, response.data.code);
    });
  } catch (err) {
    console.error("sign_up", err);
    result(false, err);
  }
};

export default {
  getToken,
  logout,
  forgotPw,
  check_captcha,
  availability_check,
  sign_up,
};
